import { useState, useEffect } from 'react';
import {
  AlaCarteApi,
  AlaCarteProduct,
} from '../../services/api/alacarte/alaCarteApi';

// Re-export for convenience
export type { AlaCarteProduct };

interface UseAlaCarteProductsReturn {
  products: AlaCarteProduct[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useAlaCarteProducts(): UseAlaCarteProductsReturn {
  const [products, setProducts] = useState<AlaCarteProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await AlaCarteApi.getProducts();
      console.log('À la carte API response:', data);

      // Ensure we always set an array
      if (Array.isArray(data)) {
        setProducts(data);
      } else {
        console.error('API returned non-array:', typeof data, data);
        setProducts([]);
        setError('Invalid data format received from server');
      }
    } catch (err: any) {
      console.error('Error fetching à la carte products:', err);
      setError(err.message || 'Failed to load à la carte products');
      setProducts([]); // Ensure it's always an array
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return {
    products,
    loading,
    error,
    refetch: fetchProducts,
  };
}
